export const computePercentile = (values, percentile) => {
  if (!values.length) {
    return 0;
  }
  const sorted = values.slice().sort((a, b) => a - b);
  const clamped = Math.min(1, Math.max(0, percentile));
  const index = clamped * (sorted.length - 1);
  const lowerIndex = Math.floor(index);
  const upperIndex = Math.ceil(index);
  if (lowerIndex === upperIndex) {
    return sorted[lowerIndex];
  }
  const weight = index - lowerIndex;
  return sorted[lowerIndex] + (sorted[upperIndex] - sorted[lowerIndex]) * weight;
};

export const rollingPercentileBands = (series, windowSize, percentiles) => {
  if (!Array.isArray(series) || series.length === 0) {
    return [];
  }
  const result = [];
  const [lowerP, upperP] = percentiles;
  const safeWindow = Math.max(1, windowSize);
  for (let i = 0; i < series.length; i += 1) {
    const start = Math.max(0, i - safeWindow + 1);
    const windowValues = series.slice(start, i + 1);
    if (!windowValues.length) {
      result.push({ lower: null, upper: null });
      continue;
    }
    const lower = computePercentile(windowValues, lowerP);
    const upper = computePercentile(windowValues, upperP);
    result.push({ lower, upper });
  }
  return result;
};
